import { cn } from '@/lib/utils'
import { Icon, type IconName } from './icon'

type AvisoTone = 'amber' | 'brand' | 'neg'

const toneStyles: Record<AvisoTone, { box: string; icon: string; text: string }> = {
  amber: { box: 'bg-amber-bg border-amber-line', icon: 'text-amber', text: 'text-[#7A4F0B]' },
  brand: { box: 'bg-brand-tint border-brand-tint-strong', icon: 'text-brand', text: 'text-brand-dark' },
  neg: { box: 'bg-neg-bg border-neg/30', icon: 'text-neg', text: 'text-neg' },
}

interface AvisoBoxProps {
  children: React.ReactNode
  tone?: AvisoTone
  icon?: IconName
  className?: string
}

/** Caixa de aviso honesto (ex.: "esse é o valor mínimo…"). Tom acolhedor, nunca punitivo. */
export function AvisoBox({ children, tone = 'amber', icon = 'bulb', className }: AvisoBoxProps) {
  const s = toneStyles[tone]
  return (
    <div className={cn('flex items-start gap-2.5 border p-3.5', s.box, className)}>
      <Icon name={icon} size={17} className={cn('mt-0.5', s.icon)} />
      <div className={cn('text-[13px] leading-relaxed', s.text)}>{children}</div>
    </div>
  )
}
